import { render, staticRenderFns } from "./ManageProductListHorizon.vue?vue&type=template&id=227bbd24&scoped=true&"
import script from "./ManageProductListHorizon.vue?vue&type=script&lang=js&"
export * from "./ManageProductListHorizon.vue?vue&type=script&lang=js&"
import style0 from "./ManageProductListHorizon.vue?vue&type=style&index=0&id=227bbd24&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "227bbd24",
  null
  
)

export default component.exports